export const laoLocationConstants = {
    LAO_LOCATIONS_LOADING: 'LAO_LOCATIONS_LOADING',
    LAO_LOCATIONS_SUCCESS: 'LAO_LOCATIONS_SUCCESS',
    LAO_LOCATIONS_FAILED: 'LAO_LOCATIONS_FAILED',
  
    LAO_LOCATION_FAV_LOADING: 'LAO_LOCATION_FAV_LOADING',
    LAO_LOCATION_FAV_SUCCESS: 'LAO_LOCATION_FAV_SUCCESS',
    LAO_LOCATION_FAV_FAILED: 'LAO_LOCATION_FAV_FAILED',
  }